import { CircleCheck } from 'lucide-react';
import { I18n } from '@/i18n/I18n';
import { ReportBundleDiagnostic } from '@/reports/bundles/types';

/** The server's compile diagnostics for the draft as last saved. */
export function BundleProblems({ diagnostics, onSelect }: { diagnostics: ReportBundleDiagnostic[]; onSelect: (file: string) => void }) {
  if (diagnostics.length === 0) {
    return <p className="flex items-center gap-2 px-3 py-2 text-xs text-emerald-700"><CircleCheck className="size-3.5" /> {I18n.get('reportBundleNoProblems')}</p>;
  }
  return (
    <ul aria-label={I18n.get('reportBundleProblems')} className="divide-y text-xs">
      {diagnostics.map((d, i) => (
        <li key={i} className="flex gap-2 px-3 py-1.5">
          {d.file ? (
            <button type="button" className="shrink-0 font-mono text-primary hover:underline" onClick={() => onSelect(d.file as string)}>
              {d.file}{d.line ? `:${d.line}${d.column !== null ? `:${d.column + 1}` : ''}` : ''}
            </button>
          ) : null}
          <span className="min-w-0 text-destructive [overflow-wrap:anywhere]">{d.message}</span>
        </li>
      ))}
    </ul>
  );
}
